import type { PortalSignableDocument } from "@dearbill/shared";

interface DocumentCopy {
  /** The document's name as the member copy refers to it, after "Sign your". */
  name: string;
  /** What signing does for the member. */
  purpose: string;
}

/**
 * Member copy for a document's Action Needed row, keyed by registry id. A
 * document without an entry uses its title.
 */
const DOCUMENT_COPY: Record<string, DocumentCopy> = {
  cms_1696: {
    name: "Appointment of Representative form (CMS-1696)",
    purpose: "This form lets DearBill speak and act for you with Medicare and your drug plan.",
  },
};

export interface DocumentActionCopy {
  title: string;
  description: string;
  label: string;
}

/**
 * The Action Needed row copy for a document the session can sign.
 */
export function documentActionCopy(doc: PortalSignableDocument): DocumentActionCopy {
  const copy = DOCUMENT_COPY[doc.documentId];
  const name = copy?.name ?? doc.title;
  return {
    title: `Sign your ${name}`,
    description: copy
      ? `${copy.purpose} Review it and add your signature.`
      : "Your document is ready. Review it and add your signature.",
    label: "Review and sign",
  };
}

/**
 * The documents that get an Action Needed row, in registration order: every
 * one this session can sign that is not currently signed.
 */
export function documentsNeedingAction(
  documents: PortalSignableDocument[],
): PortalSignableDocument[] {
  return documents.filter((d) => d.signable && d.status !== "signed");
}
